import jsPDF from 'jspdf';

const exportAsPDF = (qrCodeImage: string) => {
    const pdf = new jsPDF();
    pdf.addImage(qrCodeImage, 'PNG', 10, 10, 180, 180);
    pdf.save('qr-code.pdf');
};

export default exportAsPDF;